import { Box, Chip } from '@mui/material';
import moment from "moment";
import { useTranslation } from "react-i18next";
import { EPeriodicStatus } from "../../models/periodic/periodic";

const dateFormat = "YYYY/MM/DD";

type Color =
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";

interface PeriodicDisplayDate {
    status: EPeriodicStatus;
    scheduleDate: Date;
}

interface IPeriodicProps {
    periodic: PeriodicDisplayDate;
}

const PeriodicChips = ({ periodic }: IPeriodicProps) => {
    const { t } = useTranslation(["periodical"]);

    const getColor = (displayDate: PeriodicDisplayDate | undefined): Color => {
        const statusColorMap = new Map<EPeriodicStatus, Color>([
            [EPeriodicStatus.Accepted, "success"],
            [EPeriodicStatus.Refused, "error"],
            [EPeriodicStatus.ToVerify, "info"],
        ]);

        if (!displayDate) return "default";

        const color = statusColorMap.get(displayDate.status);
        return color
            ? color
            : moment(displayDate.scheduleDate).isBefore(moment(), "day")
                ? "warning"
                : "default";
    };

    return (
        <Box onClick={(event) => event.stopPropagation()}>
            <Chip
                size="small"
                label={moment.utc(periodic.scheduleDate).format(dateFormat)}
                sx={{ marginTop: 0.5, marginRight: 0.5 }}
                color={getColor(periodic)}
            />
        </Box>
    );
};

export default PeriodicChips;
